import React, { useEffect, useRef, useState } from 'react';

import { PUBLISH_MENU_ITEM } from "../constants/confirmTicketingConstants";
import { toastError, toastSuccess } from "../../../shared/toastHelper";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import {
  Alert,
  Button,
  Checkbox,
  DotsGrid,
  DotsVertical,
  Edit01,
  Menu,
  Modal,
  Plus,
  Select,
  Settings01,
  Tabs,
  TextInput,
  Textarea,
  Trash01
} from '@opendate-app/setlist';
import CustomWidgetBuilder from './customWidgetBuilder/CustomWidgetBuilder';
import EventOrderForm from './EventOrderForm';
import WidgetTypeDropdown, { WIDGET_TYPES } from './WidgetTypeDropdown';
import SeatedCheckoutVersionPicker from './SeatedCheckoutVersionPicker';

const axios = require('axios').default;

const footerStyle = {
  width: "100%"
};

const buttonContainerStyle = {
  height: "130px"
};

const cardStyle = {
  "background": "var(--sl-bg-primary)",
  "border": "1px solid var(--sl-border-secondary)",
  "borderRadius": "8px"
};

const placeholderTileStyle = {
  "background": "var(--sl-bg-secondary)",
  "borderRadius": "6px",
  "padding": "48px 16px",
  "textAlign": "center"
};

const itemKindStyle = {
  "color": "var(--sl-text-tertiary)",
  "fontSize": "10px",
  "marginTop": "-3px"
};

const dragHandleStyle = {
  "display": "inline-flex",
  "padding": "4px",
  "color": "var(--sl-fg-quaternary)",
  "cursor": "grab"
};

const DragHandle = ({ dragHandleProps }) => (
  <span {...dragHandleProps} aria-label="Drag to reorder" style={dragHandleStyle}>
    <DotsGrid width={16} height={16} aria-hidden="true" />
  </span>
);

const ITEM_STRATEGY_LABELS = {
  "AddOn": "Add-On",
  "Donation": "Donation",
  "Membership": "Membership",
  "Seated Add-on Chart": "Seated Add-on Chart",
  "Seated Admission Chart": "Seated Admission Chart",
  "SeatingChartEvent": "Seating Chart Event",
  "TicketType": "Ticket Type"
};

const sortedOptions = (records) => (
  [...records]
    .sort((a, b) => a.name.localeCompare(b.name))
    .map((record) => ({ value: record.id, label: record.name }))
);

const CheckoutGroupItemRow = ({
  csrfToken,
  team,
  checkoutGroupItem,
  deleteCheckoutGroupItem,
  provided
}) => {
  return (
    <div className='row'
          ref={provided.innerRef}
          {...provided.draggableProps}
          style={{
            ...provided.draggableProps.style
          }}>
      <div className='col-12 small'>
        <div className={'mb-1 p-1 d-flex justify-content-between ' + (checkoutGroupItem.item_id && checkoutGroupItem.item_type !== "SeatingChartEvent" ? "align-items-center" : "align-items-start")}>
          <DragHandle dragHandleProps={provided.dragHandleProps} />
          <div className='flex-grow-1'>
            {checkoutGroupItem.enable_donation ? (
              <div style={placeholderTileStyle}>
                <strong>MAKE A DONATION</strong>
              </div>
            ) : checkoutGroupItem.seatsio_event_id && checkoutGroupItem.seatsio_event_id.length > 0 ? (
              <div style={placeholderTileStyle}>
                <strong>ADMISSION SEATING CHART</strong>
              </div>
            ) : checkoutGroupItem.add_on_seatsio_event_id && checkoutGroupItem.add_on_seatsio_event_id.length > 0 ? (
              <div style={placeholderTileStyle}>
                <strong>ADD-ON SEATING CHART</strong>
              </div>
            ) : checkoutGroupItem.item_type === "SeatingChartEvent" ? (
              <div style={placeholderTileStyle}>
                <p className='mb-0'>
                  <strong>{checkoutGroupItem.item_name}</strong>
                </p>
                <p className="mb-0" style={{"color": "var(--sl-text-tertiary)", "fontSize": "12px"}}>
                  SEATING CHART EVENT
                </p>
              </div>
            ) : checkoutGroupItem.item_type === "MembershipProduct" ? (
              <div>
                <p className='mb-0'>
                  <strong>{checkoutGroupItem.item_name}</strong>
                </p>
                <p className="mb-0" style={itemKindStyle}>
                  MEMBERSHIP
                </p>
              </div>
            ) : checkoutGroupItem.item_type === "TicketType" ? (
              <div>
                <p className='mb-0'>
                  <strong>{checkoutGroupItem.item_name}</strong>
                </p>
                <p className="mb-0" style={itemKindStyle}>
                  TICKET TYPE
                </p>
              </div>
            ) : checkoutGroupItem.item_type === "AddOn" ? (
              <div>
                <p className='mb-0'>
                  <strong>{checkoutGroupItem.item_name}</strong>
                </p>
                <p className="mb-0" style={itemKindStyle}>
                  ADD-ON
                </p>
              </div>
            ) :null}
          </div>
          <Menu
            placement="bottom-end"
            trigger={<Button variant="tertiary" size="sm" icon={DotsVertical} aria-label="Item actions" className="ml-2" />}
            items={[
              { icon: Trash01, label: "Remove", destructive: true, onClick: () => deleteCheckoutGroupItem(team, csrfToken, checkoutGroupItem) }
            ]}
          />
        </div>
      </div>
    </div>
  );
}

const CheckoutGroupRow = ({
  csrfToken,
  team,
  checkoutGroup,
  setCheckoutGroupToEdit,
  deleteCheckoutGroup,
  provided,
  deleteCheckoutGroupItem,
  setNewCheckoutGroupItem,
  updateCheckoutGroupItemPosition,
  checkoutCategory,
  checkoutCategories,
  checkoutCategoriesChanged
}) => {
  return (
    <div className="mb-3"
          ref={provided.innerRef}
          {...provided.draggableProps}
          style={{
            ...provided.draggableProps.style,
            ...cardStyle
          }}>
      <div className="d-flex justify-content-between align-items-center"
           style={{"padding": "12px 20px 0"}}>
        <p className='mb-0 d-flex align-items-center'
            style={{"fontSize": "16px"}}>
          <DragHandle dragHandleProps={provided.dragHandleProps} />
          <strong className="ml-1">{checkoutGroup.name}</strong>
        </p>
        <Menu
          placement="bottom-end"
          trigger={<Button variant="tertiary" size="sm" icon={DotsVertical} aria-label="Group actions" />}
          items={[
            { icon: Edit01, label: "Edit", onClick: () => setCheckoutGroupToEdit(checkoutGroup) },
            {
              icon: Trash01,
              label: "Delete",
              destructive: true,
              onClick: () => {
                if(window.confirm("Are you sure you want to delete this group?")) {
                  deleteCheckoutGroup(team, csrfToken, checkoutGroup);
                }
              }
            }
          ]}
        />
      </div>
      {checkoutGroup.description && checkoutGroup.description.length > 0 ? (
        <div style={{"padding": "12px 20px 0"}}>
          <div className='small'
                style={{"color": "var(--sl-text-secondary)"}}
                dangerouslySetInnerHTML={{__html: checkoutGroup.formatted_description}}>
          </div>
        </div>
      ) : null}
      <div style={{"padding": "12px 20px 20px"}}>
        <DragDropContext onDragEnd={
                            (result) => {
                              if (!result.destination) {
                                return false;
                              }

                              var itemIndex = result.source.index;
                              var moveIndex = result.destination.index;
                              var updatedCheckoutGroupItem = Object.assign({}, checkoutGroup.checkout_group_items[itemIndex], {
                                position: (moveIndex + 1)
                              });

                              var checkoutGroupItemsCopy = [...checkoutGroup.checkout_group_items];
                              var [removed] = checkoutGroupItemsCopy.splice(itemIndex, 1);
                              checkoutGroupItemsCopy.splice(moveIndex, 0, removed);

                              var updatedGroupItems = checkoutGroupItemsCopy.map((category, index) =>
                                Object.assign({}, category, {position: (index + 1)})
                              );

                              var updatedGroup = {
                                ...checkoutGroup,
                                checkout_group_items: updatedGroupItems
                              };

                              var updatedCategory = {
                                ...checkoutCategory,
                                checkout_groups: [...checkoutCategory.checkout_groups].map((group) => {
                                  if (group.id === updatedGroup.id) {
                                    return updatedGroup;
                                  } else {
                                    return group;
                                  }
                                })
                              }
                                
                              var updated = checkoutCategories.map((category) => {
                                if (category.id === updatedCategory.id) {
                                  return updatedCategory;
                                } else {
                                  return category;
                                }
                              });

                              checkoutCategoriesChanged(updated);
                              updateCheckoutGroupItemPosition(team, csrfToken, updatedCheckoutGroupItem);
                            }
                          }>
          <Droppable droppableId={`checkout-group-items-list-${checkoutGroup.id}`}>
            {(provided, snapshot) => (
              <div {...provided.droppableProps} ref={provided.innerRef}>
                {checkoutGroup.checkout_group_items.sort((a, b) => a.position - b.position).map((checkoutGroupItem, index) =>
                  <Draggable key={"" + checkoutGroupItem.id} draggableId={"" + checkoutGroupItem.id} index={index}>
                    {(provided, snapshot) => (
                      <CheckoutGroupItemRow key={index}
                                            team={team}
                                            csrfToken={csrfToken}
                                            deleteCheckoutGroupItem={deleteCheckoutGroupItem}
                                            provided={provided}
                                            checkoutGroupItems={checkoutGroup.checkout_group_items}
                                            checkoutGroupItem={checkoutGroupItem} />
                    )}
                  </Draggable>
                )}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
        <Button
          variant="secondary"
          size="sm"
          icon={Plus}
          className="w-100 mt-1"
          onClick={() => {
            setNewCheckoutGroupItem({
              checkout_group_id: checkoutGroup.id,
              item_type: "AddOn"
            });
          }}
        >
          Add Item
        </Button>
      </div>
    </div>
  );
}

const Customize = ({
  csrfToken,
  team,
  confirm,
  confirmChanged,
  autoSaveConfirm,
  activeMenuItemChanged,
  checkoutCategories,
  checkoutCategoriesChanged,
  ticketTypes,
  addOns,
  seatingChartEvents,
  membershipProducts,
  widgetConfig,
  widgetConfigChanged,
  webOrderFormProps,
  reloadCheckoutCategories,
  reloadTicketTypes,
  reloadAddOns,
  widgetPickerAvailable,
  eventOrderFormAvailable,
  customWidgetAvailable,
  checkoutStructureSelfManaged,
  markCheckoutStructureSelfManaged
}) => {
  const widgetType = widgetConfig.widget_type || "club";

  useEffect(() => {
    if (widgetType === 'club') return;
    if (reloadCheckoutCategories) reloadCheckoutCategories();
    if (reloadTicketTypes) reloadTicketTypes();
    if (reloadAddOns) reloadAddOns();
  }, [widgetType]);

  const [widgetTypeSwitch, setWidgetTypeSwitch] = useState({ open: false, type: null });

  const confirmRef = useRef(confirm);
  confirmRef.current = confirm;

  const [savingSeatedCheckoutVersion, setSavingSeatedCheckoutVersion] = useState(false);

  const changeSeatedCheckoutVersion = (simple) => {
    if (savingSeatedCheckoutVersion) return;
    setSavingSeatedCheckoutVersion(true);
    confirmChanged({ ...confirm, simple_seated_checkout: simple });
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
    axios.patch(`/teams/${team.id}/confirms/${confirm.id}`, { confirm: { simple_seated_checkout: simple } })
      .then(() => toastSuccess(simple ? "Simple seat map checkout on" : "Standard seat map checkout on"))
      .catch((error) => {
        toastError((error.response?.data || []).join?.(", ") || "Couldn't save the seat map checkout. Please try again.");
        confirmChanged({ ...confirmRef.current, simple_seated_checkout: !simple });
      })
      .finally(() => setSavingSeatedCheckoutVersion(false));
  };

  const seatedCheckoutVersionPicker = confirm.ticketing_arrangement === "Seated" ? (
    <SeatedCheckoutVersionPicker simple={!!confirm.simple_seated_checkout} disabled={savingSeatedCheckoutVersion} previewUrl={`/confirms/${confirm.id}/web_orders/new`} onChange={changeSeatedCheckoutVersion} />
  ) : null;

  const confirmSelfManaging = (message) => {
    if (checkoutStructureSelfManaged) return true;
    if (!window.confirm(message)) return false;

    markCheckoutStructureSelfManaged();
    return true;
  };

  const saveWidgetType = (newType) => {
    if (widgetType === newType) return;

    setWidgetTypeSwitch({ open: true, type: newType });
  };

  const persistWidgetType = (newType) => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    if (widgetConfig.id) {
      return axios.patch(`/teams/${team.id}/widget_configs/${widgetConfig.id}`, {
        widget_config: { widget_type: newType }
      })
        .then(({ data }) => widgetConfigChanged(data))
        .catch(() => toastError('Failed to update widget type'));
    }

    return axios.post(`/teams/${team.id}/widget_configs`, {
      widget_config: {
        calendar_event_id: widgetConfig.calendar_event_id,
        widget_type: newType
      }
    })
      .then(({ data }) => widgetConfigChanged(data))
      .catch(() => toastError('Failed to update widget type'));
  };

  const [checkoutCategoryToEdit, setCheckoutCategoryToEdit] = useState({});
  const [checkoutGroupToEdit, setCheckoutGroupToEdit] = useState({});
  const [editingCategories, setEditingCategories] = useState(false);
  const [newCheckoutGroupItem, setNewCheckoutGroupItem] = useState({});

  const canAddSeatedAdmissionChart = () => {
    var checkoutGroupItems = checkoutCategories
      .map((category) => category.checkout_groups)
      .flat()
      .map((group) => group.checkout_group_items)
      .flat();

    var seatedAdmissionChartGroupItem = checkoutGroupItems
      .find((item) => item.seatsio_event_id);

    return (
      confirm.seatsio_event_id
        && !seatedAdmissionChartGroupItem
    );
  };

  const untakenSeatingChartEvents = (seatingChartEvents) => {
    var checkoutGroupItems = checkoutCategories
      .map((category) => category.checkout_groups)
      .flat()
      .map((group) => group.checkout_group_items)
      .flat();

    var takenSeatingChartEventIds = checkoutGroupItems
      .filter((item) => item.item_type === "SeatingChartEvent")
      .map((item) => item.item_id);

    return seatingChartEvents
      .filter((seatingChartEvent) => !takenSeatingChartEventIds.includes(seatingChartEvent.id));
  };

  const canAddSeatedAddOnChart = () => {
    var checkoutGroupItems = checkoutCategories
      .map((category) => category.checkout_groups)
      .flat()
      .map((group) => group.checkout_group_items)
      .flat();

    var seatedAddOnChartGroupItem = checkoutGroupItems
      .find((item) => item.add_on_seatsio_event_id);

    return (
      confirm.add_on_seatsio_event_id
        && !seatedAddOnChartGroupItem
    );
  };

  useEffect(() => {
    var activeCategory = checkoutCategories
      .find((category) => category._active);

    if(!activeCategory && checkoutCategories.length > 0) {
      var updated = [...checkoutCategories].map((category, index) => {
        if (index === 0) {
          return {...category, _active: true};
        } else {
          return {...category, _active: false};
        }
      });

      checkoutCategoriesChanged(updated);
    }
  }, [checkoutCategories]);

  const validCheckoutCategory = (checkoutCategory) => {
    return (
      checkoutCategory.name
        && checkoutCategory.name.length > 0
    )
  };

  const createCheckoutCategory = (team, csrfToken, confirm, name) => {
    if (!confirmSelfManaging(
      "Adding your own tab means Opendate will stop placing new ticket types, add-ons and memberships " +
      "into this event's checkout for you — you will arrange them yourself from here on. Continue?"
    )) return Promise.resolve();

    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    return axios.post(`/teams/${team.id}/checkout_categories`, {
      checkout_category: {
          calendar_event_id: confirm.id,
          name: name
        }
      })
      .then(({ data }) => {
        checkoutCategoriesChanged([...checkoutCategories, data]);
      })
      .catch(
        error => toastError("Something went wrong. Try again.")
      );
  };

  const updateCheckoutCategory = (team, csrfToken, checkoutCategory) => {
    const renamed = checkoutCategories.some(
      (category) => category.id === checkoutCategory.id && category.name !== checkoutCategory.name
    );

    if (renamed && !confirmSelfManaging(
      "Renaming this tab means Opendate will stop placing new ticket types, add-ons and memberships into " +
      "this event's checkout for you — you will arrange them yourself from here on. Continue?"
    )) return Promise.resolve();

    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    return axios.patch(`/teams/${team.id}/checkout_categories/${checkoutCategory.id}`, {
      checkout_category: {
          name: checkoutCategory.name,
          show_as_button: checkoutCategory.show_as_button
        }
      })
      .then(({ data }) => {
        var updated = [...checkoutCategories].map((category) => {
          if (category.id === checkoutCategory.id) {
            return data;
          } else {
            return category;
          }
        });

        checkoutCategoriesChanged(updated);
        setCheckoutCategoryToEdit({});
      })
      .catch(
        error => toastError("Something went wrong. Try again.")
      );
  };

  const updateCheckoutCategoryPosition = (team, csrfToken, checkoutCategory) => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    return axios.patch(`/teams/${team.id}/checkout_categories/${checkoutCategory.id}`, {
      checkout_category: {
          position: checkoutCategory.position
        }
      })
      .catch(
        error => toastError("Something went wrong. Try again.")
      );
  };

  const deleteCheckoutCategory = (team, csrfToken, checkoutCategory) => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    return axios.delete(`/teams/${team.id}/checkout_categories/${checkoutCategory.id}`)
      .then(({ data }) => {
        var updated = checkoutCategories
          .filter((category) => category.id !== checkoutCategory.id);

        checkoutCategoriesChanged(updated);
      })
      .catch(
        error => toastError("Something went wrong. Try again.")
      );
  };

  const handleWidgetTypeChange = (newType) => {
    if (newType === widgetType) return;

    if (newType === 'club') {
      saveWidgetType('club');
      return;
    }

    if (newType === 'festival') {
      saveWidgetType('festival');
      return;
    }

    if (newType === 'custom') {
      if (!customWidgetAvailable) return;

      saveWidgetType('custom');
    }
  };

  const validCheckoutGroup = (checkoutCategory) => {
    return (
      checkoutCategory.checkout_category_id
        && checkoutCategory.name
        && checkoutCategory.name.length > 0
    )
  };

  const createCheckoutGroup = (team, csrfToken, checkoutCategory) => {
    if (!confirmSelfManaging(
      "Adding your own group means Opendate will stop placing new ticket types, add-ons and memberships " +
      "into this event's checkout for you — you will arrange them yourself from here on. Continue?"
    )) return Promise.resolve();

    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    return axios.post(`/teams/${team.id}/checkout_groups`, {
        checkout_group: {
          checkout_category_id: checkoutCategory.id,
          name: "New Group"
        }
      })
      .then(({ data }) => {
        var updatedCategory = {
          ...checkoutCategory,
          checkout_groups: [...checkoutCategory.checkout_groups, data]
        }

        var updated = [...checkoutCategories].map((category) => {
          if (category.id === checkoutCategory.id) {
            return updatedCategory;
          } else {
            return category;
          }
        });

        checkoutCategoriesChanged(updated);
      })
      .catch(
        error => toastError("Something went wrong. Try again.")
      );
  };

  const updateCheckoutGroup = (team, csrfToken, checkoutGroup) => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    return axios.patch(`/teams/${team.id}/checkout_groups/${checkoutGroup.id}`, {
        checkout_group: {
          name: checkoutGroup.name,
          description: checkoutGroup.description
        }
      })
      .then(({ data }) => {
        var checkoutCategory = checkoutCategories
          .find((category) => category.id === data.checkout_category_id);

        var updatedCheckoutGroups = checkoutCategory.checkout_groups.map((group) => {
          if (group.id === checkoutGroup.id) {
            return data;
          } else {
            return group;
          }
        });

        var updatedCategory = {
          ...checkoutCategory,
          checkout_groups: updatedCheckoutGroups
        }

        var updated = [...checkoutCategories].map((category) => {
          if (category.id === checkoutCategory.id) {
            return updatedCategory;
          } else {
            return category;
          }
        });

        checkoutCategoriesChanged(updated);
      })
      .catch(
        error => toastError("Something went wrong. Try again.")
      );
  };

  const updateCheckoutGroupPosition = (team, csrfToken, checkoutGroup) => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    return axios.patch(`/teams/${team.id}/checkout_groups/${checkoutGroup.id}`, {
        checkout_group: {
          position: checkoutGroup.position
        }
      })
      .catch(
        error => toastError("Something went wrong. Try again.")
      );
  };

  const deleteCheckoutGroup = (team, csrfToken, checkoutGroup) => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    return axios.delete(`/teams/${team.id}/checkout_groups/${checkoutGroup.id}`)
      .then(({ data }) => {
        var checkoutCategory = checkoutCategories
          .find((category) => category.id === data.checkout_category_id);

        var updatedCheckoutGroups = checkoutCategory.checkout_groups
          .filter((group) => group.id !== checkoutGroup.id);

        var updatedCategory = {
          ...checkoutCategory,
          checkout_groups: updatedCheckoutGroups
        }

        var updated = [...checkoutCategories].map((category) => {
          if (category.id === checkoutCategory.id) {
            return updatedCategory;
          } else {
            return category;
          }
        });

        checkoutCategoriesChanged(updated);
      })
      .catch(
        error => toastError("Something went wrong. Try again.")
      );
  };

  const validCheckoutGroupItem = (checkoutGroupItem) => {
    return (
      checkoutGroupItem.checkout_group_id
        && (
          (checkoutGroupItem.item_type && checkoutGroupItem.item_id)
            || checkoutGroupItem.enable_donation
            || checkoutGroupItem.seatsio_event_id
            || checkoutGroupItem.add_on_seatsio_event_id
        )
    )
  };

  const createCheckoutGroupItem = (team, csrfToken, checkoutGroupItem) => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    return axios.post(`/teams/${team.id}/checkout_group_items`, {
        checkout_group_item: {
          checkout_group_id: checkoutGroupItem.checkout_group_id,
          item_id: checkoutGroupItem.item_id,
          item_type: checkoutGroupItem.item_type,
          seatsio_event_id: checkoutGroupItem.seatsio_event_id,
          add_on_seatsio_event_id: checkoutGroupItem.add_on_seatsio_event_id,
          enable_donation: checkoutGroupItem.enable_donation
        }
      })
      .then(({ data }) => {
        var checkoutGroup = checkoutCategories
          .map((category) => category.checkout_groups)
          .flat()
          .find((group) => group.id === data.checkout_group_id);

        var checkoutCategory = checkoutCategories
          .find((category) => category.id === checkoutGroup.checkout_category_id);

        var updatedCheckoutCategory = {
          ...checkoutCategory,
          checkout_groups: checkoutCategory.checkout_groups.map((group) => {
            if (group.id === checkoutGroup.id) {
              return {
                ...group,
                checkout_group_items: [...group.checkout_group_items, data]
              }
            } else {
              return group;
            }
          })
        }

        var updated = [...checkoutCategories].map((category) => {
          if (category.id === checkoutCategory.id) {
            return updatedCheckoutCategory;
          } else {
            return category;
          }
        });

        checkoutCategoriesChanged(updated);
      })
      .catch(
        error => toastError("Something went wrong. Try again.")
      );
  };

  const updateCheckoutGroupItemPosition = (team, csrfToken, checkoutGroupItem) => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    return axios.patch(`/teams/${team.id}/checkout_group_items/${checkoutGroupItem.id}`, {
        checkout_group_item: {
          position: checkoutGroupItem.position
        }
      })
      .catch(
        error => toastError("Something went wrong. Try again.")
      );
  };

  const deleteCheckoutGroupItem = (team, csrfToken, checkoutGroupItem) => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    return axios.delete(`/teams/${team.id}/checkout_group_items/${checkoutGroupItem.id}`)
      .then(({ data }) => {
        var checkoutGroup = checkoutCategories
          .map((category) => category.checkout_groups)
          .flat()
          .find((group) => group.id === data.checkout_group_id);

        var checkoutCategory = checkoutCategories
          .find((category) => category.id === checkoutGroup.checkout_category_id);

        var updatedCheckoutCategory = {
          ...checkoutCategory,
          checkout_groups: checkoutCategory.checkout_groups.map((group) => {
            if (group.id === checkoutGroup.id) {
              return {
                ...group,
                checkout_group_items: group.checkout_group_items.filter((item) => item.id !== data.id)
              }
            } else {
              return group;
            }
          })
        }

        var updated = [...checkoutCategories].map((category) => {
          if (category.id === checkoutCategory.id) {
            return updatedCheckoutCategory;
          } else {
            return category;
          }
        });

        checkoutCategoriesChanged(updated);
      })
      .catch(
        error => toastError("Something went wrong. Try again.")
      );
  };

  const selfManagedAlert = (
    <Alert
      color="warning"
      role="status"
      title="You are arranging this checkout yourself."
      description={
        "Because you added, duplicated or renamed a tab or group, Opendate will not build any new " +
        "tabs or groups for this event. New ticket types, add-ons and memberships still land in a tab " +
        "that already holds that kind of item. Anything else you will need to place yourself, or fans " +
        "will not be able to buy it. Renaming a group is safe and does not affect this. Remove the tabs " +
        "and groups you added, and Opendate resumes filing items for you."
      }
    />
  );

  const selfManagedBanner = (
    <div style={{"padding": "16px 25px 0"}} hidden={!checkoutStructureSelfManaged}>
      {selfManagedAlert}
    </div>
  );

  const pendingWidgetType = widgetTypeSwitch.type;
  const pendingWidgetTypeLabel = pendingWidgetType
    && WIDGET_TYPES.find((t) => t.value === pendingWidgetType).label;
  const hidesTabs = pendingWidgetType === 'club' && checkoutCategories.length > 0;
  const closeWidgetTypeSwitch = () => setWidgetTypeSwitch({ ...widgetTypeSwitch, open: false });

  const widgetTypeSwitchModal = (
    <Modal
      open={widgetTypeSwitch.open}
      type="warning"
      title={`Switch to ${pendingWidgetTypeLabel}?`}
      description={
        hidesTabs
          ? "This changes your public checkout right away. The Club layout hides the tabs and groups on " +
            "this event from fans. They are kept, and come back if you switch to Festival or Custom."
          : "This changes your public checkout right away."
      }
      confirmLabel={`Switch to ${pendingWidgetTypeLabel}`}
      onConfirm={() => {
        persistWidgetType(pendingWidgetType);
        closeWidgetTypeSwitch();
      }}
      onClose={closeWidgetTypeSwitch}
    />
  );

  if (widgetConfig.widget_type === 'custom') {
    return (
      <>
        {widgetTypeSwitchModal}
        {widgetPickerAvailable && (
          <WidgetTypeDropdown
            widgetType="custom"
            onSelect={handleWidgetTypeChange}
            customWidgetAvailable={customWidgetAvailable}
          />
        )}
        {seatedCheckoutVersionPicker}
        <CustomWidgetBuilder
          csrfToken={csrfToken}
          orderFormAvailable={eventOrderFormAvailable}
          confirm={confirm}
          selfManagedAlert={selfManagedAlert}
          checkoutStructureSelfManaged={checkoutStructureSelfManaged}
          team={team}
          widgetConfig={widgetConfig}
          checkoutCategories={checkoutCategories}
          ticketTypes={ticketTypes}
          addOns={addOns}
          memberships={membershipProducts}
          seatingChartEvents={seatingChartEvents}
          webOrderFormProps={webOrderFormProps}
          onWidgetConfigChange={widgetConfigChanged}
          onCheckoutCategoriesChange={checkoutCategoriesChanged}
          onWidgetTemplatesChange={() => {}}
          confirmSelfManaging={confirmSelfManaging}
          reloadCheckoutCategories={reloadCheckoutCategories}
        />
      </>
    );
  }

  return (
    <>
      {widgetTypeSwitchModal}
      {widgetPickerAvailable && (
        <WidgetTypeDropdown
          widgetType={widgetType}
          onSelect={handleWidgetTypeChange}
          customWidgetAvailable={customWidgetAvailable}
        />
      )}
      {seatedCheckoutVersionPicker}
      {selfManagedBanner}
      <div className="row">
      <div className="col-12">
        {widgetType === "festival" ? (
          <div style={{ padding: '25px' }}>
            <div className="d-flex align-items-end" style={{"marginBottom": "20px"}}>
              <div className="flex-grow-1" style={{"minWidth": 0}}>
                <Tabs
                  aria-label="Checkout tabs"
                  collapseBelow={0}
                  overflow
                  items={checkoutCategories.map((category) => ({ value: category.id, label: category.name }))}
                  value={(checkoutCategories.find((category) => category._active) || {}).id}
                  onChange={(categoryId) => {
                    var updated = [...checkoutCategories].map((category) => (
                      {...category, _active: category.id === categoryId}
                    ));

                    checkoutCategoriesChanged(updated);
                  }}
                />
              </div>
              <Button
                variant="link-color"
                size="sm"
                icon={Settings01}
                className="ml-3 mb-2"
                onClick={() => setEditingCategories(true)}
              >
                Configure
              </Button>
            </div>
            <div className='row'>
              <div className='col-12'>
                {checkoutCategories.map((category, categoryIndex) =>
                  <div key={categoryIndex}
                        className={(category._active ? "" : "d-none")}>
                    <DragDropContext onDragEnd={
                                        (result) => {
                                          if (!result.destination) {
                                            return false;
                                          }

                                          var itemIndex = result.source.index;
                                          var moveIndex = result.destination.index;
                                          var updatedCheckoutGroup = Object.assign({}, category.checkout_groups[itemIndex], {
                                            position: (moveIndex + 1)
                                          });

                                          var checkoutGroupsCopy = [...category.checkout_groups];
                                          var [removed] = checkoutGroupsCopy.splice(itemIndex, 1);
                                          checkoutGroupsCopy.splice(moveIndex, 0, removed);

                                          var updatedGroups = checkoutGroupsCopy.map((category, index) =>
                                            Object.assign({}, category, {position: (index + 1)})
                                          );

                                          var updatedCategory = {
                                            ...category,
                                            checkout_groups: updatedGroups
                                          }
                                            
                                          var updated = checkoutCategories.map((category) => {
                                            if (category.id === updatedCategory.id) {
                                              return updatedCategory;
                                            } else {
                                              return category;
                                            }
                                          });

                                          checkoutCategoriesChanged(updated);
                                          updateCheckoutGroupPosition(team, csrfToken, updatedCheckoutGroup);
                                        }
                                      }>
                      <Droppable droppableId={`checkout-group-list-${category.id}`}>
                        {(provided, snapshot) => (
                          <div {...provided.droppableProps} ref={provided.innerRef}>
                            {category.checkout_groups.sort((a, b) => a.position - b.position).map((checkoutGroup, index) =>
                              <Draggable key={"" + checkoutGroup.id} draggableId={"" + checkoutGroup.id} index={index}>
                                {(provided, snapshot) => (
                                  <CheckoutGroupRow key={index}
                                      csrfToken={csrfToken}
                                      team={team}
                                      setCheckoutGroupToEdit={setCheckoutGroupToEdit}
                                      deleteCheckoutGroup={deleteCheckoutGroup}
                                      provided={provided}
                                      deleteCheckoutGroupItem={deleteCheckoutGroupItem}
                                      updateCheckoutGroupItemPosition={updateCheckoutGroupItemPosition}
                                      setNewCheckoutGroupItem={setNewCheckoutGroupItem}
                                      checkoutCategory={category}
                                      checkoutCategories={checkoutCategories}
                                      checkoutCategoriesChanged={checkoutCategoriesChanged}
                                      checkoutGroup={checkoutGroup} />
                                )}
                              </Draggable>
                            )}
                            {provided.placeholder}
                          </div>
                        )}
                      </Droppable>
                    </DragDropContext>
                    <Button
                      variant="secondary"
                      icon={Plus}
                      className="w-100"
                      onClick={() => createCheckoutGroup(team, csrfToken, category)}
                    >
                      Add Group
                    </Button>
                  </div>
                )}
              </div>
            </div>
          </div>
        ) : null}
      </div>
      {eventOrderFormAvailable && (
        <div className="row" style={{ marginTop: 24, width: '100%' }}>
          <div className="col-12">
            <div style={{ padding: '0 25px' }}>
              {widgetType === 'festival' && <hr style={{ borderTop: '1px solid var(--sl-border-secondary)', margin: '0 0 24px' }} />}
              <EventOrderForm team={team} confirm={confirm} ticketTypes={ticketTypes} />
            </div>
          </div>
        </div>
      )}
      <div className="row" style={footerStyle}>
        <div className="col-12 d-flex justify-content-end align-items-end" style={buttonContainerStyle}>
          <Button variant="primary" onClick={() => activeMenuItemChanged(PUBLISH_MENU_ITEM)}>
            Next
          </Button>
        </div>
      </div>
      <Modal
        open={editingCategories}
        title="Edit Tabs"
        width={650}
        onClose={
          () => {
            setEditingCategories(false);
            setCheckoutCategoryToEdit({});
          }
        }
      >
        <DragDropContext onDragEnd={
                            (result) => {
                              if (!result.destination) {
                                return false;
                              }

                              var itemIndex = result.source.index;
                              var moveIndex = result.destination.index;
                              var updatedCheckoutCategory = Object.assign({}, checkoutCategories[itemIndex], {
                                position: (moveIndex + 1)
                              });

                              var checkoutCategoriesCopy = [...checkoutCategories];
                              var [removed] = checkoutCategoriesCopy.splice(itemIndex, 1);
                              checkoutCategoriesCopy.splice(moveIndex, 0, removed);

                              var updated = checkoutCategoriesCopy.map((category, index) =>
                                Object.assign({}, category, {position: (index + 1)})
                              );

                              checkoutCategoriesChanged(updated);
                              updateCheckoutCategoryPosition(team, csrfToken, updatedCheckoutCategory);
                            }
                          }>
          <Droppable droppableId="checkout-category-list">
            {(provided, snapshot) => (
              <div {...provided.droppableProps} ref={provided.innerRef}>
                {checkoutCategories.sort((a, b) => a.position - b.position).map((category, index) =>
                  <Draggable key={"" + category.id} draggableId={"" + category.id} index={index}>
                    {(provided, snapshot) => (
                      <div className='mb-2 p-3 d-flex justify-content-between align-items-center'
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            style={{
                              ...provided.draggableProps.style,
                              ...cardStyle
                            }}
                            key={index}>
                        <DragHandle dragHandleProps={provided.dragHandleProps} />
                        {category.id === checkoutCategoryToEdit.id ? (
                          <form className="d-flex align-items-center flex-grow-1 ml-2"
                                onSubmit={
                                  (e) => {
                                    e.preventDefault();

                                    if(validCheckoutCategory(checkoutCategoryToEdit)){
                                      updateCheckoutCategory(team, csrfToken, checkoutCategoryToEdit);
                                    }
                                  }
                                }>
                            <div className="flex-grow-1">
                              <TextInput
                                size="sm"
                                aria-label="Tab name"
                                autoFocus={true}
                                value={checkoutCategoryToEdit.name || ""}
                                onChange={
                                  (e) => {
                                    setCheckoutCategoryToEdit({
                                      ...checkoutCategoryToEdit,
                                      name: e.target.value
                                    });
                                  }
                                }
                                placeholder="Tab Name" />
                            </div>
                            <Button
                              variant="link-gray"
                              size="sm"
                              className="ml-2"
                              onClick={() => setCheckoutCategoryToEdit({})}
                            >
                              Cancel
                            </Button>
                            <Button
                              type="submit"
                              variant="primary"
                              size="sm"
                              className="ml-2"
                              disabled={!validCheckoutCategory(checkoutCategoryToEdit)}
                            >
                              Save
                            </Button>
                          </form>
                        ) : (
                          <>
                            <div className='text-truncate flex-grow-1 ml-2'>
                              {category.name}
                            </div>
                            <div className='d-flex align-items-center'>
                              <div className="mr-2" style={{"whiteSpace": "nowrap"}}>
                                <Checkbox
                                  size="sm"
                                  id={`checkout-category-show-as-button-${category.id}`}
                                  label="Show as button"
                                  checked={category.show_as_button || false}
                                  onChange={
                                    (e) => {
                                      var updated = {...category, show_as_button: e.target.checked};
                                      updateCheckoutCategory(team, csrfToken, updated);
                                    }
                                  }
                                />
                              </div>
                              <Menu
                                placement="bottom-end"
                                trigger={<Button variant="tertiary" size="sm" icon={DotsVertical} aria-label="Tab actions" />}
                                items={[
                                  { icon: Edit01, label: "Rename", onClick: () => setCheckoutCategoryToEdit(category) },
                                  {
                                    icon: Trash01,
                                    label: "Delete",
                                    destructive: true,
                                    onClick: () => {
                                      if(window.confirm("Are you sure you want to delete this tab?")) {
                                        deleteCheckoutCategory(team, csrfToken, category);
                                      }
                                    }
                                  }
                                ]}
                              />
                            </div>
                          </>
                        )}
                      </div>
                    )}
                  </Draggable>
                )}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
        <Button
          variant="secondary"
          icon={Plus}
          className="w-100"
          onClick={() => createCheckoutCategory(team, csrfToken, confirm, "New Tab")}
        >
          Add Tab
        </Button>
      </Modal>
      <Modal
        open={Object.keys(checkoutGroupToEdit).length > 0}
        title="Edit Group"
        width={650}
        onClose={
          () => setCheckoutGroupToEdit({})
        }
      >
        <form onSubmit={
                (e) => {
                  e.preventDefault();

                  if(validCheckoutGroup(checkoutGroupToEdit)){
                    updateCheckoutGroup(team, csrfToken, checkoutGroupToEdit);
                    setCheckoutGroupToEdit({});
                  }
                }
              }>
          <div className="mb-3">
            <TextInput
              id="checkout-group-name"
              label="Name"
              autoFocus={true}
              value={checkoutGroupToEdit.name || ""}
              onChange={
                (e) => {
                  setCheckoutGroupToEdit({
                    ...checkoutGroupToEdit,
                    name: e.target.value
                  });
                }
              }
              placeholder="Name" />
          </div>
          <div className="mb-3">
            <Textarea
              id="checkout-group-description"
              label="Description"
              rows={10}
              value={checkoutGroupToEdit.description || ""}
              onChange={
                (e) => {
                  setCheckoutGroupToEdit({
                    ...checkoutGroupToEdit,
                    description: e.target.value
                  });
                }
              }
              placeholder="Description" />
          </div>
          <div className='text-right'>
            <Button
              type="submit"
              variant="primary"
              size="sm"
              disabled={!validCheckoutGroup(checkoutGroupToEdit)}
            >
              Save
            </Button>
          </div>
        </form>
      </Modal>
      <Modal
        open={Object.keys(newCheckoutGroupItem).length > 0}
        title="Add Item"
        width={650}
        onClose={
          () => setNewCheckoutGroupItem({})
        }
      >
        <form onSubmit={
                (e) => {
                  e.preventDefault();

                  if(validCheckoutGroupItem(newCheckoutGroupItem)){
                    createCheckoutGroupItem(team, csrfToken, newCheckoutGroupItem);
                    setNewCheckoutGroupItem({});
                  }
                }
              }>
          <div className="mb-3">
            <Select
              id="checkout-group-item-category"
              label="Type"
              options={
                [
                  "AddOn",
                  confirm.donations_enabled && "Donation",
                  team.can_access_memberships && (membershipProducts || []).length > 0 && "Membership",
                  canAddSeatedAddOnChart() && "Seated Add-on Chart",
                  canAddSeatedAdmissionChart() && "Seated Admission Chart",
                  seatingChartEvents.length > 0 && "SeatingChartEvent",
                  "TicketType"
                ]
                  .filter(Boolean)
                  .map((strategy) => ({ value: strategy, label: ITEM_STRATEGY_LABELS[strategy] }))
              }
              value={newCheckoutGroupItem.strategy || "AddOn"}
              onChange={
                (newValue) => {
                  var attrs = {
                    strategy: newValue,
                    item_type: "",
                    item_id: "",
                    enable_donation: false,
                    seatsio_event_id: "",
                    add_on_seatsio_event_id: ""
                  };

                  switch (newValue) {
                    case 'AddOn':
                      attrs = Object.assign(attrs, {item_type: "AddOn"});
                      break;
                    case 'Donation':
                      attrs = Object.assign(attrs, {enable_donation: true});
                      break;
                    case 'Membership':
                      attrs = Object.assign(attrs, {item_type: "MembershipProduct"});
                      break;
                    case 'TicketType':
                      attrs = Object.assign(attrs, {item_type: "TicketType"});
                      break;
                    case 'Seated Add-on Chart':
                      attrs = Object.assign(attrs, {add_on_seatsio_event_id: confirm.add_on_seatsio_event_id});
                      break;
                    case 'Seated Admission Chart':
                      attrs = Object.assign(attrs, {seatsio_event_id: confirm.seatsio_event_id});
                      break;
                    case 'SeatingChartEvent':
                      attrs = Object.assign(attrs, {item_type: "SeatingChartEvent"});
                      break;
                  }

                  setNewCheckoutGroupItem({
                    ...newCheckoutGroupItem,
                    ...attrs
                  });
                }
              } />
          </div>
          {newCheckoutGroupItem.item_type === "TicketType" ? (
            <div className="mb-3">
              <Select
                id="checkout-group-item-ticket-type"
                label="Ticket Type"
                placeholder="Choose Ticket Type"
                searchable
                options={sortedOptions(ticketTypes.filter((tt) => !tt.seating_chart_category_key))}
                value={newCheckoutGroupItem.item_id || null}
                onChange={(itemId) => setNewCheckoutGroupItem({...newCheckoutGroupItem, item_id: itemId})} />
            </div>
          ) : newCheckoutGroupItem.item_type === "AddOn" ? (
            <div className="mb-3">
              <Select
                id="checkout-group-item-add-on"
                label="Add-On"
                placeholder="Choose Add-On"
                searchable
                options={sortedOptions(addOns.filter((ao) => !ao.seating_chart_category_key))}
                value={newCheckoutGroupItem.item_id || null}
                onChange={(itemId) => setNewCheckoutGroupItem({...newCheckoutGroupItem, item_id: itemId})} />
            </div>
          ) : newCheckoutGroupItem.item_type === "MembershipProduct" ? (
            <div className="mb-3">
              <Select
                id="checkout-group-item-membership-product"
                label="Membership Product"
                placeholder="Choose Membership Product"
                searchable
                options={sortedOptions(membershipProducts || [])}
                value={newCheckoutGroupItem.item_id || null}
                onChange={(itemId) => setNewCheckoutGroupItem({...newCheckoutGroupItem, item_id: itemId})} />
            </div>
          ) : newCheckoutGroupItem.item_type === "SeatingChartEvent" ? (
            <div className="mb-3">
              <Select
                id="checkout-group-item-seating-chart-event"
                label="Seating Chart Event"
                placeholder="Choose Seating Chart Event"
                searchable
                options={sortedOptions(untakenSeatingChartEvents(seatingChartEvents))}
                value={newCheckoutGroupItem.item_id || null}
                onChange={(itemId) => setNewCheckoutGroupItem({...newCheckoutGroupItem, item_id: itemId})} />
            </div>
          ) : null}
          <div className='text-right'>
            <Button
              type="submit"
              variant="primary"
              size="sm"
              disabled={!validCheckoutGroupItem(newCheckoutGroupItem)}
            >
              Add
            </Button>
          </div>
        </form>
      </Modal>
    </div>
    </>
  );
};

export default Customize;
